import {Component, OnInit, Input, ViewChild, OnDestroy} from '@angular/core';
import {InteractionsService} from 'src/app/services/interactions.service';
import {MethodsService} from 'src/app/services/methods.service';

@Component({
    selector: 'app-mappa',
    templateUrl: './mappa.component.html',
    styleUrls: ['./mappa.component.scss']
})
export class MappaComponent implements OnInit, OnDestroy {

    @Input('interactionId') interactionId;

    @ViewChild('mappa') mappa;
    public localStorage = localStorage;
    public interaction;
    public items = [];
    public rows;
    public columns;
    public mapImage;
    public selectedOpera;
    public imageWidth;
    public imageHeight;
    public mappaWidth;
    public opere;
    private interactionsSubscriber;
    public responseAlert = '';
    public citta;
    public language;
    constructor(
        private interactionsService: InteractionsService,
        private methods: MethodsService
    ) {
      this.language = localStorage.getItem('l')
    }

    ngOnInit(): void {
        this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
            this.items = [];
            this.selectedOpera = null;
            this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
            console.log('inte', this.interaction);
            this.methods.get('assets/data/' +this.language +'/' + this.interaction.content.configId + '.config.json')
                .subscribe(config => {
                    this.rows = config.rows;
                    this.columns = config.columns;
                    this.mapImage = config.mapImage;
                    this.opere = config.opere;
                    this.interaction.tentativiMax = config.tentativiMax;
                    this.interaction.tentativiRimanenti = config.tentativiMax;
                    if (this.interaction.completed.status === 'success') {
                        this.opere.map(opera => {
                            opera.found = true;
                        });
                    }
                    this.imageWidth = config.imageWidth;
                    this.imageHeight = config.imageHeight;
                    this.mappaWidth = this.mappa.nativeElement.offsetWidth;
                    this.getTheGrid();
                });
        });
    }

    getTheGrid() {
        this.items = [];
        let row = 0;
        let col = 0;
        for (let i = 0; i < this.rows * this.columns; i++) {
            const width = this.mappaWidth / this.columns;
            const height = ((this.mappaWidth * this.imageHeight) / this.imageWidth) / this.rows;
            this.items.push({
                id: i,
                width: width,
                height: height,
                backgroundPosition: (col * width) * -1 + 'px ' + (row * height) * -1 + 'px',
                opacity: 1
            });
            if (col < this.columns - 1) {
                col++;
            } else {
                col = 0;
                row++;
            }
        }
    }

    onSelectOpera(opera) {
        if (opera.found) {
            return;
        }
        this.selectedOpera = opera;
    }

    onSelectMappa(mapItem) {
        if (!this.selectedOpera || this.selectedOpera.found) {
            return;
        }
        if (this.selectedOpera.mapItemIds.includes(mapItem.id)) { // POSIZIONE CORRETTA
            this.responseAlert = 'ok';
            this.selectedOpera.found = true;
            this.citta = this.selectedOpera.location;
            if (this.opere.filter(opera => opera.found).length === this.opere.length) { // POSIZIONATE TUTTE
                this.interaction.completed = {
                    onComplete: true,
                    status: 'success'
                };
                this.interactionsService.setCompleted(this.interaction);
                this.interactionsService.updateInteraction(this.interaction);
            }
        } else {  // POSIZIONE ERRATA
            this.responseAlert = 'ko';
            this.interaction.tentativiRimanenti--;
            if (this.interaction.tentativiRimanenti <= 0) {
                this.interaction.completed = {
                    onComplete: true,
                    status: 'failed'
                };
                this.interactionsService.setCompleted(this.interaction);
                this.interactionsService.updateInteraction(this.interaction);
            }
        }
        setTimeout(() => {
            this.responseAlert = '';
        }, 1500);
    }

    ngOnDestroy() {
        this.interactionsSubscriber.unsubscribe();
    }

}
